export default [
    {
        path: '/',
        name: 'list',
        component: () => import('@/views/SharedHosting/SharedHosting'),
    },
    {
        path: '/:id',
        name: 'detail',
        component: () =>
            import('@/views/SharedHostingDetail/SharedHostingDetail'),
    },
];
